/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { type SeriesOption } from 'echarts';
import { util } from 'echarts/core';
import { isObject } from './utils';

/**
 * ! 配置项不应该覆盖掉用户侧的配置，一定要首先监测一下用户的配置是否存在
 */
export function overrideIfUndefined<V = unknown>(value: V, override: V) {
  return typeof value === 'undefined' ? override : value;
}

/**
 * 对象数组转number数组
 * @param item
 * @returns
 */
function getDataValue(item: { value: number } | number) {
  if (isObject(item)) {
    return item.value;
  }
  return item;
}

/**
 * 根据Y坐标轴--（series类型）--seriesData的依赖关系，处理series数据，形成映射数组（暂定）
 * 数据结构如：
 * [
 *  {
 *    'stack': [
 *            [1,2,3],
 *            [1,2,3],
 *            ...
 *          ],
 *      ''
 *   }
 * ]
 */
export function getStackData(seriesArr: SeriesOption[]) {
  const stackedDataArr = [];
  const stackDataMap = {};
  const stackItemArr = [];
  seriesArr.forEach(series => {
    if (typeof series.stack === 'undefined') {
      stackedDataArr.push(series.data.map(getDataValue));
    } else {
      const stackMode = series.stackStrategy || 'samesign';
      const { stack } = series;
      if (isObject(stackDataMap[stack])) {
        stackDataMap[stack].stackMode = stackMode;
        (stackDataMap[stack].stackData as []).push(series.data.map(getDataValue));
      } else {
        stackDataMap[stack] = util.clone({
          stackMode,
          stackData: []
        });
        stackDataMap[stack].stackData.push(series.data.map(getDataValue));
        stackItemArr.push(stack);
      }
    }
  });

  stackItemArr.forEach(stackName => {
    const { stackMode, stackData } = stackDataMap[stackName];
    let maxLen = 0;
    // eslint-disable-next-line no-return-assign
    stackData.forEach((arr: []) => (maxLen = Math.max(maxLen, arr.length)));
    const resArr = [];
    for (let col = 0; col < maxLen; col++) {
      let max = 0;
      let min = 0;
      let sum = 0;
      for (let row = 0; row < stackData.length; row++) {
        const item = stackData[row][col] || 0;
        switch (stackMode) {
          case 'samesign':
            item > 0 ? (max += item) : (min += item);
            break;
          case 'all':
            sum += item;
            max = Math.max(max, sum);
            min = Math.min(min, sum);
            break;
          case 'positive':
            max = item > 0 ? max + item : max;
            sum += item;
            min = Math.min(min, sum);
            break;
          case 'negative':
            min = item < 0 ? min + item : min;
            sum += item;
            max = Math.max(max, sum);
            break;
          default:
        }
      }
      resArr.push(min);
      resArr.push(max);
    }
    stackedDataArr.push(resArr);
  });
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return stackedDataArr;
}

/**
 * @param value Value of data, if want to calculate the data of whole time, flat and formatter it before start
 * @param index Dimension index
 * @param sortFn Sort function from smallest to largest, if not set, use the default sort function
 * @returns [number, number]
 */
export function getExtremeValues(
  value: unknown[],
  index?: number,
  sortFn?: (a: any, b: any) => number
): [number, number] {
  const target = value.map(d => d[index] as number);
  const sortFnResult = sortFn || ((a: any, b: any) => a - b);
  target.sort(sortFnResult);
  return [target[0], target[target.length - 1]];
}

// eslint-disable-next-line complexity, sonarjs/cognitive-complexity
export function defaultsDeep<
  T extends { [k: string]: any } | any[],
  S extends { [k: string]: any } | any[]
>(target: T, source: S, { overlay = false, depth = 0, currentDepth = 0 } = {}): T & S {
  const keysArr = Array.isArray(source)
    ? Array.from(Array(source.length), (_, i) => i)
    : Object.keys(source);

  for (let i = 0; i < keysArr.length; i += 1) {
    const key = keysArr[i];

    if (overlay ? source[key] != null : (target as T & S)[key] == null) {
      if (
        currentDepth < depth &&
        (Array.isArray(source[key]) || (typeof source[key] === 'object' && source[key] !== null))
      ) {
        // eslint-disable-next-line no-param-reassign
        target[key] = defaultsDeep(
          (target[key] || (Array.isArray(source[key]) ? [] : {})) as T,
          source[key] as S,
          { overlay, depth, currentDepth: currentDepth + 1 }
        );
      } else {
        // eslint-disable-next-line no-param-reassign
        target[key] = source[key] as T & S;
      }
    }
  }

  return target as T & S;
}
